import md5 from "md5";

export const hashWithMd5 = (originalData) => {
  if (!originalData || typeof originalData !== "string") return null;
  return md5(originalData);
};
